import { BiIconChevronRight } from '@bi-digital/icons-react';
import { BiChip, BiTypography } from 'bi-web-components-react';

export type ListItemProps = {
    icon: React.ComponentType<Pick<HTMLBiIconClockElement, 'size' | 'color' | 'slot'>>;
    text?: string | null;
    srOnlyText?: string;
    link?: string;
    type?: 'link' | 'text';
};

export function ListItem({ icon: Icon, text, srOnlyText, link, type = 'text' }: ListItemProps) {
    if (!text || (type === 'link' && !link)) return null;

    return (
        <li>
            <BiChip color='primary-light' size='large' aria-label={srOnlyText} href={link}>
                <Icon slot='icon' size='medium' color='gray' aria-hidden='true' />
                <BiTypography color='grayStrong'>{text}</BiTypography>
                {type === 'link' && <BiIconChevronRight size='medium' aria-hidden='true'></BiIconChevronRight>}
            </BiChip>
        </li>
    );
}
